let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Cz1S")).then(() => parcelRequire('bn01I'));